import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";
import ContactTable from "components/contact/ContactTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect } from "react";
import ContactServices from "services/ContactServices";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import { FiRefreshCcw } from "react-icons/fi";
import { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";

const Contact = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  // const {
  //   state: { adminInfo },
  // } = useContext(AdminContext);

  const { data, loading, error } = useAsync(ContactServices.getAllContact);
  const { setIsUpdate } = useContext(SidebarContext);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // const hideView = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "contact" && perm.view === 1
  // );
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "contact" && perm.view === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "contact" && perm.edit === 1,
      );

  const [contactData, setContactData] = useState([]);
  const {
    contactRef,
    dataTable,
    serviceData,
    handleSubmitContact,
    currentPage,
  } = useFilter(contactData, itemsPerPage);
  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  useEffect(() => {
    if (data && data.status && Array.isArray(data.data)) {
      const updatedData = data.data.map(
        ({ id, name, email_id, mobile_no, subject, ...rest }) => ({
          id,
          name,
          email_id,
          mobile_no,
          subject,
          ...rest,
        }),
      );
      setContactData(updatedData);
    } else {
      console.error("Invalid data structure:", data);
    }
  }, [data]);
  const [status, setStatus] = useState("");
  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div style={{ width: "600px" }}>
                  <Input
                    ref={contactRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    autoComplete="off"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitContact}
                  />
                </div>
                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Email </TableCell>
                        <TableCell>Mobile Number </TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>View</TableCell>
                      </tr>
                    </TableHeader>
                    <ContactTable
                      contact={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      setContactData={setContactData}
					  hideEdit={hideEdit}

					  
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <NotFound title="There are no Contacts." />
            )}{" "}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Contact;
